import React, { FC } from "react";
import GenericAuthForm from "../GenericAuthForm/GenericAuthForm";

const ForgotPassword: FC = () => {
   return <GenericAuthForm />;
};

export default ForgotPassword;
